module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"users":{"title":"Users","login":"Login","email":"Email","activeUser":"Active"}},"ru":{"users":{"title":"Пользователи","login":"Логин","email":"Почта","activeUser":"Активная"}}}')
  delete Component.options._Ctor
}
